import { useContext, useEffect, useMemo } from 'react';
import { useNextMicro, useUpdate } from '@bydesign-ui/hooks';
import { SubMenuContext } from '../context/SubMenu';
import { useMenu } from './useMenu';
export function useSubMenu() {
  var update = useNextMicro(useUpdate());
  var menu = useMenu();
  useMemo(function () {
    menu.addListener('active-menus-update', update);
    menu.addListener('open-menus-update', update);
  }, []);
  useEffect(function () {
    return function () {
      menu.removeListener('active-menus-update', update);
      menu.removeListener('open-menus-update', update);
    };
  }, []);
  return useContext(SubMenuContext);
}